import axios, { AxiosError } from 'axios';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import {ResponseError} from "../../../models/common/Response";

export type UseDeleteMenuMasterParams = {
    sid?: string;
    id?: string;
}

export function useDeleteMenuMaster(
    options?: UseMutationOptions<
        ResponseError,
        AxiosError<ResponseError>,
        UseDeleteMenuMasterParams
    >
) {
    return useMutation({
        mutationFn: params => {
            const accessToken = localStorage.getItem('LG_APPLICATION');
            return axios.delete('/v1/configuration/lis/menu', {
                headers: {
                    Authorization: `Bearer ${accessToken}`
                },
                params
            });
        },
        ...options
    });
}
